module.exports = __webpack_public_path__ + "static/media/prisma.1433f9a1.png";